import { reactive, ref, computed } from 'vue';
import apiservice from '@/services/apiservice.js';
import useFormValidation from '@/hooks/formValidation.js';
import { i18n } from '@/main.js';


export default function useSalaForm(hasDate = false, filters = null){

  const { t } = i18n.global; 
  const locale = ref(i18n.global.locale.value); 

  const initDate = filters?.date != null ? filters.date : null;
  const initSala = filters?.sala != null ? {...filters?.sala} : null;

  const form = reactive({
    ...(hasDate ? {
      date: {
        label: computed(() => t('forms.data',locale.value)),
        type: "date",
        required: true,
        value: initDate,
        index: 0,
        errors:[],
        msgs:[]
      }
    } : {}),
    sala: {
      label: computed(() => t('forms.sala',locale.value)),
      required: true,
      type: "select",
      options: [],
      value: initSala,
      index: 0,
      errors:[],
      msgs:[]
    },
  })
  
  let fetching = ref(null);

  const options = reactive({
    sala: [],
  });

  let controller;

  const getOptions = (currentweek,currentLocal) => {
    if (controller) {
      controller.abort();
    }
    controller = new AbortController();
    const { signal } = controller;

    return apiservice.fetchSalas(currentweek,locale.value,signal).then(data => {
      return {sala: data}
    })
  }

  const fetchOptions = (currentweek) => {
    if (controller) {
      controller.abort();
    }
    controller = new AbortController();
    const { signal } = controller;

    const timer = setTimeout(() => {
      fetching.value = true;
    }, 150);

    return apiservice.fetchSalas(currentweek,locale.value,signal).then(data => {
      form.sala.options = data;
      options.sala = [...data];
      fetching.value = false;
      clearTimeout(timer);
    });
  };

  const getSubmitData = (data,currentweek) => {
    const { validateForm } = useFormValidation();
    if(validateForm(form)){
      let selectedDates = data != null ? data : {
        "start": currentweek.start,
        "end": currentweek.end
      }
      let params = {
        sala: form.sala.value,
        datas: selectedDates
      };
      return [selectedDates,params,form];
    }
    return null;
  }

  const setFormDate = (currentweek) => {
    if(form.date){
      form.date.value = currentweek;
    }
  }

  const checkFormAfterChanginDate = () => {}


  return {
    getOptions,
    form,
    fetchOptions,
    getSubmitData,
    fetching,
    setFormDate,
    checkFormAfterChanginDate
  }
}